
export function PressRevealDirective() {
    "ngInject";

    return {
        restrict: "A",
        scope: {
            pressReveal: "="
        },
        link: function (scope, element) {
            var el = element[0];

            function set(value) {
                scope.$apply(function () {
                    scope.pressReveal = value;
                });
            }

            function down() {
                set(true);
            }
            function up() {
                set(false);
            }

            el.addEventListener("pointerdown", down);
            el.addEventListener("pointerup", up);
            el.addEventListener("pointerleave", up);
            el.addEventListener("pointercancel", up);

            scope.$on("$destroy", function () {
                el.removeEventListener("pointerdown", down);
                el.removeEventListener("pointerup", up);
                el.removeEventListener("pointerleave", up);
                el.removeEventListener("pointercancel", up);
            });
        }
    };
}
